var _rect, _text, _text2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDroitPenalRoutier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: 400,
    fill: "#B0B0B0",
    fontFamily: "Montserrat",
    fontSize: 80,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "DROIT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: 520,
    fill: "#B0B0B0",
    fontFamily: "Montserrat",
    fontSize: 80,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "P\xC9NAL")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: 640,
    fill: "#B0B0B0",
    fontFamily: "Montserrat",
    fontSize: 80,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "ROUTIER")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroitPenalRoutier);
export default __webpack_public_path__ + "static/media/droit_penal_routier.a168fc62a70994c8ee4efd59fc5029e5.svg";
export { ForwardRef as ReactComponent };